import { Trip } from 'data/records'
import { resource, member, findSelector } from 'data/helpers/apiv3'
import { emptyPayload as payload } from 'data/helpers/emptyPayload'

const PHOTO_ADDED = 'apiv3/trip/photo_added'
const PHOTO_REMOVED = 'apiv3/trip/photo_removed'
const DIRTY_UPDATE = 'apiv3/trip/dirty_update' // update v3 state without a server roundtrip

const [api, actions] = resource(Trip, [
  ['read', member.get('', ['privacyCode', 'count'])]
])
actions.photoAdded = (tripId, photoId) => ({
  type: PHOTO_ADDED,
  payload,
  meta: { apiv3source: 'trip', tripId, photoId }
})
actions.photoRemoved = (tripId, photoId) => ({
  type: PHOTO_REMOVED,
  payload,
  meta: { apiv3source: 'trip', tripId, photoId }
})
actions.dirtyUpdate = (trip) => ({
  type: DIRTY_UPDATE,
  payload,
  meta: { apiv3source: 'trip', trip }
})

const selectors = {
  ...findSelector(Trip)
}

const reducers = {
  [PHOTO_ADDED]: (state, action) => {
    const { tripId, photoId } = action.meta
    const trip = state.getIn(['id', tripId], null)
    if (!trip) return state
    return state.setIn(['id', tripId, 'photoIds'], trip.photoIds.concat([photoId]))
  },
  [PHOTO_REMOVED]: (state, action) => {
    const { tripId, photoId } = action.meta
    const trip = state.getIn(['id', tripId], null)
    if (!trip) return state
    return state.setIn(['id', tripId, 'photoIds'], trip.photoIds.filter(pid => pid !== photoId))
  },
  [DIRTY_UPDATE]: (state, action) => {
    const { trip } = action.meta
    return state.setIn(['id', trip.id], trip)
  }
}

const initialState = {}

export {
  api as tripApi,
  actions as tripActions,
  selectors as tripSelectors,
  reducers as tripReducers,
  initialState as tripInitialState
}
